import useTenant from "~/composables/Tenant/common/useTenant";

export default defineNuxtRouteMiddleware((to) => {
  const { tenant } = useTenant();
  const config = useRuntimeConfig();

  const isPreview = config.public.VERSION === "PREVIEW";
  const isStaging = config.public.ENVIRONMENT === "staging";

  const tenantPages: Record<string, boolean> = {
    "/tenant/login": true,
    "/tenant/info": true,
  };

  // prevent user from visiting tenant pages in published mode
  if (!isPreview && tenantPages[to.path]) {
    return navigateTo("/");
  }

  if (isPreview) {
    // TODO: should be removed when staging is agreed upon
    // prevent unauthed user from visiting any page in preview mode
    if (
      !tenant.value &&
      to.path !== "/tenant/login" &&
      to.path !== "/tenant/_magic" &&
      !isStaging
    ) {
      return navigateTo("/tenant/login");
    }

    if (!tenant.value && to.path === "/tenant/info" && isStaging) {
      return navigateTo("/tenant/login");
    }

    // prevent authed user from vising tenant login page
    if (to.path === "/tenant/login" && tenant.value?.token) {
      return navigateTo("/");
    }
  }
});
